enum PriceType {
	AddFixed = "add_fixed",
	AddPercentage = "add_percentage",
	SubtractFixed = "subtract_fixed",
	SubtractPercentage = "subtract_percentage",
}

export default PriceType;
